module.exports = __webpack_public_path__ + "img/89823918001116.86860f91.png";